import { render, staticRenderFns } from "./EventInfoView.vue?vue&type=template&id=2f1a6c90"
import script from "./EventInfoView.vue?vue&type=script&lang=js"
export * from "./EventInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports